import { ArrowRightIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import { BookOpenIcon, PlusIcon } from '@heroicons/react/24/outline';

import { Logo } from '@/components/Logo';
import Footer from '@/renderer/Footer';
import Header from '@/renderer/Header';
import { usePageContext } from '@/renderer/utils/usePageContext';

import srcBetOnlineDark from './components/betonline-dark.png';
import srcBetOnline from './components/betonline.png';

export default BetOnlinePage;

export function BetOnline() {
  const {
    config: { title },
  } = usePageContext();

  return (
    <div className="flex h-40 min-h-[stretch] flex-1 grow flex-col justify-between overflow-hidden">
      <Header
        title="Join BetOnline and get $250 RAS credit"
        Icon={BookOpenIcon}
        className="py-2 md:hidden"
      />
      <div className="overflow-auto">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="relative mx-auto max-w-2xl space-y-8 pt-20 pb-10 text-center">
            <div className="space-y-8 rounded bg-gradient-to-br from-emerald-500/20 via-cyan-400/10 to-emerald-500/20 p-4 sm:p-8 dark:bg-white/5">
              <div className="mx-auto flex w-fit flex-col items-center space-y-4 sm:flex-row sm:space-x-4 sm:space-y-0">
                <Logo className="size-16 select-none sm:size-12" />
                <PlusIcon
                  className="h-auto w-6 shrink-0 text-zinc-500 dark:text-zinc-400"
                  aria-hidden="true"
                />
                <img
                  src={srcBetOnline}
                  alt="BetOnline logo"
                  title="BetOnline"
                  className="h-10 w-auto self-center dark:hidden"
                />
                <img
                  src={srcBetOnlineDark}
                  alt="BetOnline logo"
                  title="BetOnline"
                  className="hidden h-10 w-auto self-center dark:inline-block"
                />
              </div>
              <h1 className="font-semibold text-xl text-zinc-900 tracking-tight sm:text-2xl dark:text-zinc-200">
                <span>Join BetOnline and get $250 RAS credit</span>
              </h1>
              <div className="p-4 text-center">
                <h4>Use the button below and deposit $250 or more to BetOnline.</h4>
                <a
                  href="https://record.betonlineaffiliates.ag/_VTO-Tl87kobYJMJFEJBL7mNd7ZgqdRLk/1/"
                  target="_blank"
                  rel="noreferrer"
                  className="w-full sm:w-auto"
                >
                  <li className="group mt-4 inline-flex w-full flex-row items-center justify-center space-x-0.5 overflow-hidden rounded bg-emerald-500 p-2 px-6 font-medium text-sm text-white ring-1 ring-emerald-500 ring-inset transition hover:bg-emerald-400 sm:w-auto">
                    <span>Join BetOnline</span>
                    <ChevronRightIcon className="size-5 shrink-0 group-hover:hidden" />
                    <ArrowRightIcon className="hidden size-5 p-px transition-transform group-hover:block" />
                  </li>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="relative mt-8 px-4 sm:mt-0 sm:px-6 lg:px-8">
          <div className="prose prose-sm prose-zinc dark:prose-invert mx-auto max-w-prose prose-a:font-semibold prose-a:text-emerald-500 hover:prose-a:text-emerald-600">
            <div className="text-left">
              <h4 className="mb-8">Offer terms & conditions</h4>
              <ul className="list-disc space-y-2 pl-4 text-xs text-zinc-500 dark:text-zinc-400">
                <li>New BetOnline customers only.</li>
                <li>RAS's referral link must be used.</li>
                <li>Make first deposit of $250 or more.</li>
                <li>
                  Contact RAS on{' '}
                  <a
                    href="/support-chat"
                    className="text-zinc-500 dark:text-zinc-200 dark:hover:text-zinc-300"
                    target="_self"
                  >
                    Support Chat
                  </a>
                  . Eligibility will be confirmed next business day.
                </li>
                <li>
                  RAS will add $250 to your account balance which will automatically apply toward
                  your next RAS order. Promotional RAS balance is not redeemable for cash.
                </li>
              </ul>
            </div>
            <hr className="h-px border-0 bg-zinc-900/10 dark:bg-white/10" />
            <h3 className="mb-8">
              BetOnline is a must-have account for sharp bettors, and the most underrated sportsbook
              that welcomes winning action in the industry.
            </h3>
            <ul>
              <li>Does not ban sharp action (including RAS releases)</li>
              <li>Home of the "Hold The Line" promo for RAS release shows</li>
              <li>Hassle-free withdrawals</li>
              <li>First to post lines in many markets</li>
              <li>Huge betting menu</li>
              <li>
                High limits and re-bet functionality (every 61 seconds or when the line moves)
              </li>
              <li>
                VIP Program with No Rollover (reserve the right to remove eligibility for rewards on
                sharp action)
              </li>
            </ul>
            <hr className="h-px border-0 bg-zinc-900/10 dark:bg-white/10" />
            <div className="text-center">
              <h4 className="font-normal">
                Deposit $250 or more to BetOnline and use the button below to receive a $250 credit
                to use toward any RAS service.
              </h4>
              <a
                href="https://record.betonlineaffiliates.ag/_VTO-Tl87kobYJMJFEJBL7mNd7ZgqdRLk/1/"
                target="_blank"
                rel="noreferrer"
                className="w-full sm:w-auto"
              >
                <li className="group mt-4 inline-flex w-full flex-row items-center justify-center space-x-0.5 overflow-hidden rounded bg-emerald-500 p-2 px-6 font-medium text-sm text-white ring-1 ring-emerald-500 ring-inset transition hover:bg-emerald-400 sm:w-auto">
                  <span>Join BetOnline</span>
                  <ChevronRightIcon className="size-5 shrink-0 group-hover:hidden" />
                  <ArrowRightIcon className="hidden size-5 p-px transition-transform group-hover:block" />
                </li>
              </a>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

// Main component
function BetOnlinePage() {
  return <BetOnline />;
}
